<form #form="ngForm" [formGroup]="wellForm" class="form-field-full">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader">
        <mat-icon>add</mat-icon> Add Well
      </h2>
    </div>
    <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
      <a mat-raised-button href="https://apps.wrd.state.or.us/apps/gw/well_log/Default.aspx" target="_blank" title="Find a Well Report">
        Find a Well Report <mat-icon>open_in_new</mat-icon></a>
    </div>
  </div>
  <br />
  <section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>
  <mat-horizontal-stepper [linear]="isLinear" #stepper labelPosition="bottom">
    <!-- step 1 -->
    <mat-step [stepControl]="formLookupGroup" [formGroup]="formLookupGroup" label="Lookup">
      <h4 style="margin-bottom:0px;">Well Lookup</h4>
      <small>Fill out the form (1 field required) below to Lookup a Well</small>
      <br /><br />
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Address 1" formControlName="address1">
                  <mat-error *ngIf="formLookupGroup.controls['address1'].hasError('required')">
                    Address is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="City" formControlName="city">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="State" formControlName="state">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Zip" formControlName="zip">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label>County</mat-label>
                  <mat-select id="county" name="county" formControlName="county">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.value}}">{{item.text}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <!-- well lookup results -->
      <h4 *ngIf="wellLookup" style="margin-bottom:0px;">Well Lookup Results</h4>
      <small *ngIf="wellLookup">Select the link to view a Well or click Next to continue Adding a New Well</small>
      <span *ngIf="wellLookup"><br /><br /></span>
      <mat-table *ngIf="wellLookup" [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
        style="overflow-x: auto;">
        <mat-row>Lookup Results</mat-row>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <ng-container matColumnDef="wellId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>OHA Well Id</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <a [routerLink]="['/well/edit/', result.wellId]"
              title="Edit OHA Well {{result.wellId}}">{{result.wellId}}</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="wellAddress1">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Address 1</mat-header-cell>
          <mat-cell *matCellDef="let result">{{result.wellAddress1}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="wellCity">
          <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
          <mat-cell *matCellDef="let result">{{result.wellCity}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="wellState">
          <mat-header-cell *matHeaderCellDef mat-sort-header>State</mat-header-cell>
          <mat-cell *matCellDef="let result">{{result.wellState}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="wellZip">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
          <mat-cell *matCellDef="let result">{{result.wellZip}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="wellCounty">
          <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
          <mat-cell *matCellDef="let result">{{result.wellCounty}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="wellLog">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Well Log</mat-header-cell>
          <mat-cell *matCellDef="let result">{{result.wellLog}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="wellTag">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Well Tag</mat-header-cell>
          <mat-cell *matCellDef="let result">{{result.wellTag}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="score">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Score</mat-header-cell>
          <mat-cell *matCellDef="let result">{{result.score}}</mat-cell>
        </ng-container>
      </mat-table>
      <br />
      <mat-paginator *ngIf="wellLookup" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]"
        #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
      <span *ngIf="wellLookup"><br /></span>
      <div fxLayout="row wrap" class="matero-row">
        <br />
        <span>&nbsp;&nbsp;</span>
        <button mat-raised-button color="basic" (click)="clearStep('1');" title="Clear">Clear</button>
        <span>&nbsp;&nbsp;</span>
        <button *ngIf="!wellLookup" mat-raised-button color="primary" (click)="lookupWell();" [disabled]="processing"
          title="Lookup">Lookup</button>
        <button *ngIf="wellLookup" mat-raised-button color="accent" (click)="lookupWell();"
          title="Lookup">Lookup</button>
        <span *ngIf="wellLookup">&nbsp;&nbsp;</span>
        <button *ngIf="wellLookup" mat-raised-button color="primary" matStepperNext
          (click)="lookupAddress();lookupButton();" title="Next">Next</button>
      </div>
    </mat-step>

    <!-- step 2 -->
    <mat-step [stepControl]="formWellGroup" [formGroup]="formWellGroup" label="Well">
      <h4>Well Information</h4>
      <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row" *ngIf="showProgressBar">
        <strong>Looking up Lat/Long</strong>
        <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        <br /><br />
      </div>
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row" [formGroup]="formLookupGroup">
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Address 1" formControlName="address1"
                    value="{{formLookupGroup.value.address1}}">
                  <mat-error *ngIf="formLookupGroup.controls['address1'].hasError('required')">
                    Address is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100" [formGroup]="formWellGroup">
                <mat-form-field>
                  <input matInput placeholder="Address 2" formControlName="address2">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="City" formControlName="city" value="{{formLookupGroup.value.city}}">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="State" formControlName="state" value="{{formLookupGroup.value.state}}">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Zip" formControlName="zip" value="{{formLookupGroup.value.zip}}"
                    (change)="lookupCountyLatLong();">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row" [formGroup]="formWellGroup">
              <div fxFlex="20" fxFlex.lt-sm="100" [formGroup]="formLookupGroup">
                <mat-form-field>
                  <mat-label>County</mat-label>
                  <mat-select id="county" name="county" formControlName="county"
                    value="{{formLookupGroup.value.county}}">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.value}}">{{item.text}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Well Log" formControlName="wellLog"
                    matTooltipClass="tooltip"
                    matTooltip="This is a combination of county name and numbers; for example, a well log in Marion County could be MARI-12345">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Well Tag" formControlName="tag"
                    matTooltipClass="tooltip"
                    matTooltip="Well label/tag number (L-#####). Wells built after 1996 should have a metal well tag on or near the wellhead">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Well Type" formControlName="wellType" readonly>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100" fxLayout="column">
                <mat-form-field>
                  <mat-label>Date Well Established</mat-label>
                  <input id="dateWellEstablished" name="dateWellEstablished" formControlName="dateWellEstablished"
                    placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepicker" />
                  <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="center start">
                &nbsp;
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Latitude" formControlName="latitude"
                    value="{{formWellGroup.value.latitude}}">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Longitude" formControlName="longitude"
                    value="{{formWellGroup.value.longitude}}">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100" fxLayoutAlign="start center">
                <mat-checkbox id="tribalLand" name="tribalLand" formControlName="tribalLand" (click)="updateTribalLand();">
                  <small>Tribal Land</small>
                </mat-checkbox>
              </div>
              <div fxFlex="66.67" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Tribal Land Name" formControlName="tribalLandName" [readonly]="tribalLandReadOnly == true">
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Tax Lot" formControlName="taxLot">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Sample Point" formControlName="samplePoint">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input type="text" matInput placeholder="Depth" formControlName="depth">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Datum" formControlName="datum">
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" fxLayout="column">
                <mat-form-field>
                  <input matInput placeholder="Coordinate Collection Method"
                    formControlName="coordinateCollectionMethod">
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Township" formControlName="township">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Range" formControlName="range">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Section" formControlName="section">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <mat-form-field>
                  <textarea rows="3" cols="100" placeholder="Comments" formControlName="comment" matInput></textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field><input matInput placeholder="Monitoring Location Id"
                    formControlName="monitoringLocationId"></mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field><input matInput placeholder="Monitoring Location Name"
                    formControlName="monitoringLocationName"></mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Monitoring Location Desc"
                    formControlName="monitoringLocationDescription">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <mat-form-field>
                  <textarea rows="3" cols="100" placeholder="Monitoring Location Comments"
                    formControlName="monitoringLocationComments" matInput></textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row wrap" class="matero-row">
        <span>&nbsp;&nbsp;</span>
        <button mat-raised-button color="accent" matStepperPrevious title="Back">Back</button>
        <span>&nbsp;&nbsp;</span>
        <button mat-raised-button color="basic" (click)="clearStep('2');" title="Clear">Clear</button>
        <span>&nbsp;&nbsp;</span>
        <button mat-raised-button color="warn" *ngIf="showLookupButton" (click)="lookupCountyLatLong();"
          title="Clear">Lookup Lat/Long</button>
        <span *ngIf="showLookupButton">&nbsp;&nbsp;</span>
        <button mat-raised-button color="primary" matStepperNext title="Next">Next</button>
      </div>
    </mat-step>

    <!-- step 3 -->
    <mat-step>
      <ng-template matStepLabel>Review &amp; Create</ng-template>
      <h4>Add Well</h4>
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="20" fxFlex.lt-sm="100"><strong>Address 1</strong><br />{{formLookupGroup.value.address1}}</div>
              <div fxFlex="20" fxFlex.lt-sm="100"><strong>Address 2</strong><br />{{formWellGroup.value.address2}}</div>
              <div fxFlex="20" fxFlex.lt-sm="100"><strong>City</strong><br />{{formLookupGroup.value.city}}</div>
              <div fxFlex="20" fxFlex.lt-sm="100"><strong>State</strong><br />{{formLookupGroup.value.state}}</div>
              <div fxFlex="20" fxFlex.lt-sm="100"><strong>Zip</strong><br />{{formLookupGroup.value.zip}}</div>
            </div>
            <br />
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="20" fxFlex.lt-sm="100"><strong>County</strong><br />{{formLookupGroup.value.county}}</div>
              <div fxFlex="20" fxFlex.lt-sm="100"><strong>Well Log</strong><br />{{formWellGroup.value.wellLog}}</div>
              <div fxFlex="20" fxFlex.lt-sm="100"><strong>Well Tag</strong><br />{{formWellGroup.value.tag}}</div>
              <div fxFlex="20" fxFlex.lt-sm="100"><strong>Well Type</strong><br />{{formWellGroup.getRawValue().wellType}}</div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <strong>Date Established</strong>
                <br />
                {{formWellGroup.value.dateWellEstablished | date:'shortDate'}}
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <strong>Override Lat/Long</strong>
                <br />
                <span *ngIf="formWellGroup.value.overrideLatLong == false">No</span>
                <span *ngIf="formWellGroup.value.overrideLatLong == true">Yes</span>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Latitude</strong><br />{{formWellGroup.value.latitude}}</div>
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Longitude</strong><br />{{formWellGroup.value.longitude}}</div>
            </div>
            <br />
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <strong>Tribal Land</strong>
                <br />
                <span *ngIf="formWellGroup.value.tribalLand == false">No</span>
                <span *ngIf="formWellGroup.value.tribalLand == true">Yes</span>
              </div>
              <div fxFlex="66.67" fxFlex.lt-sm="100"><strong>Tribal Land Name</strong><br />{{formWellGroup.value.tribalLandName}}</div>
            </div>
          </mat-card>
        </div>
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Tax Lot</strong><br />{{formWellGroup.value.taxLot}}</div>
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Sample Point</strong><br />{{formWellGroup.value.samplePoint}}</div>
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Depth</strong><br />{{formWellGroup.value.depth}}</div>
            </div>
            <br />
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="50" fxFlex.lt-sm="100"><strong>Datum</strong><br />{{formWellGroup.getRawValue().datum}}</div>
              <div fxFlex="50" fxFlex.lt-sm="100"><strong>Coordinate Collection Method</strong><br />{{formWellGroup.getRawValue().coordinateCollectionMethod}}
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Township</strong><br />{{formWellGroup.value.township}}</div>
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Range</strong><br />{{formWellGroup.value.range}}</div>
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Section</strong><br />{{formWellGroup.value.section}}</div>
            </div>
            <br />
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="100" fxFlex.lt-sm="100"><strong>Comments</strong><br />{{formWellGroup.value.comment}}</div>
            </div>
          </mat-card>
        </div>
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Monitoring Location ID</strong><br />{{formWellGroup.value.monitoringLocationId}}</div>
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Monitoring Location Name</strong><br />{{formWellGroup.value.monitoringLocationName}}</div>
              <div fxFlex="33.33" fxFlex.lt-sm="100"><strong>Monitoring Location Desc</strong><br />{{formWellGroup.value.monitoringLocationDescription}}</div>
            </div>
            <br />
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="100" fxFlex.lt-sm="100"><strong>Monitoring Location Comments</strong><br />{{formWellGroup.value.monitoringLocationComments}}</div>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <mat-card-title>Decommissioning</mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-select id="decommissioned" name="decommissioned" formControlName="decommissioned" required>
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let item of oregonWellDataService.decommissionedOptions" value="{{item}}">{{item}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field> 
                  <input id="dateDecommissioned" name="dateDecommissioned" formControlName="dateDecommissioned"
                  placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickeDateDecommissioned" />
                  <mat-datepicker-toggle matSuffix [for]="datepickeDateDecommissioned"></mat-datepicker-toggle>
                  <mat-datepicker #datepickeDateDecommissioned>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div> 
            </div> 
          </mat-card>
        </div> 
      </div>

      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <button mat-raised-button color="accent" matStepperPrevious title="Back">Back</button>
          <span>&nbsp;&nbsp;</span>
          <button type="submit" name="submit" (click)="onSubmit()" mat-raised-button color="primary"
            title="Add Well">Add Well</button>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</form>